import routes from '@/routes/index'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_URL,
  linkActiveClass: 'linkActive',
  linkExactActiveClass: 'linkActive',
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

///////////////////////////////////////////////////////////////////////////////////////////////////
//    ______                     __
//   / ____/_  ______ __________/ /____
//  / / __/ / / / __ `/ ___/ __  / ___/
// / /_/ / /_/ / /_/ / /  / /_/ (__  )
// \____/\__,_/\__,_/_/   \__,_/____/
//
///////////////////////////////////////////////////////////////////////////////////////////////////

// router.beforeEach((...[to, , next]) => {
//   // redirect unathenticated users to login screen
//   if (to.name !== 'Login' && !authClient.authenticated) next({ name: 'Login' })
//   else next()
// })

export default router
